import { render, staticRenderFns } from "./accepted-currencies.vue?vue&type=template&id=707378b2&"
import script from "./accepted-currencies.vue?vue&type=script&lang=js&"
export * from "./accepted-currencies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports